<template>
    <Sheet v-loading="loading.actions['setting']">
        <el-tabs value="sys">
            <el-tab-pane label="系統參數設定" name="sys" lazy>
                <sys-form></sys-form>
            </el-tab-pane>
            <el-tab-pane label="月份資訊設定" name="month" lazy>
                <month-setting></month-setting>
            </el-tab-pane>
            <el-tab-pane label="場地設定" name="room" lazy>
                <room-setting></room-setting>
            </el-tab-pane>
            <el-tab-pane label="信件設定" name="template" lazy>
                <mail-setting></mail-setting>
            </el-tab-pane>
            <el-tab-pane label="網頁內容設定" name="viewContent" lazy>
                <view-content-setting></view-content-setting>
            </el-tab-pane>
        </el-tabs>
    </Sheet>
</template>

<script>
    import {mapState} from 'vuex';
    import SysForm from './SysForm';
    import MonthSetting from './MonthSetting';
    import RoomSetting from './RoomSetting';
    import MailSetting from './MailSetting';
    import ViewContentSetting from './ViewContentSetting';
    export default {
        name: 'Setting',
        components: {
            RoomSetting,
            MonthSetting,
            MailSetting,
            SysForm,
            ViewContentSetting
        },
        computed:{
            ...mapState(['loading']),
        }
    }
</script>

<style scoped>

</style>